import React from 'react'
import "./Controllers.css"
import { IoIosInformationCircleOutline, IoIosSearch, IoMdLocate } from "react-icons/io";
import { BiHide, BiShow } from "react-icons/bi";
import { GiSolarSystem } from "react-icons/gi";
import { useStateValue } from '../../utils/provider/StateProvider';


function Controllers() {
    const [{showInfo, showSearchBar, showModals, locateMe}, dispatch] = useStateValue();


    // Show Modal Info:
    const handleShowInfo = () => {

        dispatch({
            type: "SHOW_INFO",
            showInfo: !showInfo
        })
    }

    const handleSearch = () => {
        dispatch({
            type: "SHOW_SEARCH",
            showSearchBar: !showSearchBar
        })
    }

    const handleHide = () => {
        dispatch({
            type: "SHOW_MODALS",
            showModals: !showModals
        })
    }

    const handleLocateMe = () => {
        dispatch({
            type: "LOCATE_ME",
            locateMe: !locateMe
        })
    }


  return (
    <div className='modalViewDiv controller_outer_div'>
        <div className='controller_menu'>
            <p className={`controller_icons ${showInfo && 'controller_icons_selected'}`} onClick={() => handleShowInfo()}><IoIosInformationCircleOutline /></p>
            <p className={`controller_icons controller_icons_hover`} onClick={() => handleSearch()}><IoIosSearch /></p>
            {/* <p className={`controller_icons controller_icons_hover`} onClick={() => handleSearch()}><GiSolarSystem /></p> */}
            <p className={`controller_icons ${showModals && 'controller_icons_selected'}`} onClick={() => handleHide()}>{showModals ? <BiHide /> : <BiShow />}</p>
            <p className={`controller_icons controller_icons_hover`} onClick={() => handleLocateMe()}><IoMdLocate /></p>
        </div>


    </div>
  )
}

export default Controllers